import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_ClientId,
    authority: process.env.REACT_APP_Auth_Authority,
    redirectUri: process.env.REACT_APP_RedirectURI,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

const loginRequest = {
  scopes: ["openid", "offline_access"],
};

const tokenRequest = {
  scopes: [process.env.REACT_APP_SCOPE],
  forceRefresh: true,
  refreshTokenExpirationOffsetSeconds: 7200,
};

const graphConfig = {
  graphUsersEndpoint: "https://graph.microsoft.com/v1.0/users",
};

const pca = new PublicClientApplication(msalConfig);
// Share one initialization/redirect-processing promise across the app. This prevents
// components from starting interactive authentication before MSAL is ready.
const msalReady = pca.initialize().then(() => pca.handleRedirectPromise());

export { msalConfig, loginRequest, tokenRequest, graphConfig, pca, msalReady };
